import { FC, useMemo } from 'external/react'
import { convertDateToText } from 'utilities/text'

const subscriptionStatusText = {
    'active': 'Próximo pago',
    'pending': 'Suscripción vigente hasta el',
    'canceled': 'Suscripción cancelada',
    'past_due': 'Pago no realizado'
}

const paymentStatusText = {
    'active': 'Suscripción vigente hasta el',
    'expired': 'Suscripción expiró el',
}

type SubscriptionStatusProps = {
    className?: string
    status: keyof typeof subscriptionStatusText
    periondEnds: string
    paymentMode: string
}

const SubscriptionStatus:FC<SubscriptionStatusProps> = props => {

    const {status, periondEnds, className, paymentMode} = props

    const statusText = useMemo(() => (paymentMode === 'subscription'
        ? subscriptionStatusText
        : paymentStatusText
    )[status], [status, paymentMode])

    const periodEndsText = useMemo(() => convertDateToText(periondEnds, true), [periondEnds]) 

    return (
        <div className={className}>
            <p className='fw-bold-500 m-auto'>{statusText}</p>
            <span className='fn-s-14'>{periodEndsText}</span>
        </div>
    )
}

export {SubscriptionStatus as default}